import styled from "styled-components";
export const SidebarBuyButtonWrapper = styled.div`
  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
          padding-bottom: ${props.theme.spacePx(breakpoint, 9)};          
        `;
    })}
`;